import { render, staticRenderFns } from "./AutoheightTextarea.vue?vue&type=template&id=0585ace6"
import script from "./AutoheightTextarea.vue?vue&type=script&lang=js"
export * from "./AutoheightTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports